import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { paymentStatusRequest } from './payment-status-actions';

const PaymentStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Extract query params (e.g., ?payment-success=success&orderUid=CO202603079999-D110)
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('payment-success') || searchParams.get('status') || 'unknown';
  const orderUid = searchParams.get('orderUid') || searchParams.get('order_id');
  const transactionId = searchParams.get('transactionId') || searchParams.get('transaction_id');
  const message = searchParams.get('message');

  // Extract all required fields for API call
  const paymentPayload = {
    order_id: searchParams.get('order_id'),
    order_token: searchParams.get('order_token'),
    payment_status: searchParams.get('payment_status'),
    payment_message: searchParams.get('payment_message'),
    payment_mode: searchParams.get('payment_mode'),
    transaction_id: searchParams.get('transaction_id'),
    amount: parseFloat(searchParams.get('amount')),
    reference_id: searchParams.get('reference_id'),
    signature: searchParams.get('signature')
  };

//   Parameter	Meaning
// order_id	Your order ID
// cf_payment_id	Cashfree payment ID
// payment_status	SUCCESS / FAILED
// payment_amount	Amount
// payment_currency	INR

  useEffect(() => {
    // Only call API if required fields are present
    if (paymentPayload.order_id && paymentPayload.order_token && paymentPayload.payment_status && paymentPayload.signature) {
      dispatch(paymentStatusRequest(paymentPayload));
    }
  }, [dispatch, location.search]);

  // Get payment status from Redux
  const paymentStatus = useSelector(state => state.paymentStatus);

// order_id: The unique order ID you sent in the request.
// order_token: The token generated for the order.
// payment_status: Status of the payment (e.g., SUCCESS, FAILED).
// payment_message: Message describing the payment status.
// payment_mode: Mode of payment used (e.g., CARD, UPI).
// transaction_id: Cashfree transaction ID.
// amount: Amount paid.
// reference_id: Bank reference ID (if available).
// signature: Hash for verifying the response.

  let displayMessage = '';
  let displayColor = '#eb6c20';
  if (paymentStatus?.success) {
    displayMessage = 'Payment successful! Your order is confirmed.';
    displayColor = '#009e60';
  } else if (paymentStatus?.error) {
    displayMessage = typeof paymentStatus.error === 'string'
      ? paymentStatus.error
      : 'Payment failed. Please try again or contact support.';
    displayColor = '#eb6c20';
  } else if (status === 'success') {
    displayMessage = 'Payment successful! Your order is confirmed.';
    displayColor = '#009e60';
  } else if (status === 'failure') {
    displayMessage = 'Payment failed. Please try again or contact support.';
    displayColor = '#eb6c20';
  } else {
    displayMessage = 'Payment status unknown.';
    displayColor = '#eb6c20';
  }

  return (
    <div className="payment-status-container" style={{ padding: 32, textAlign: 'center' }}>
      <h2>Payment Status</h2>
      <div style={{ fontSize: '1.2rem', margin: '24px 0', color: displayColor }}>
        {displayMessage}
      </div>
     
      {orderUid && (
        <div style={{ marginBottom: 16 }}>Order ID: <b>{orderUid}</b></div>
      )}
       {transactionId && (
        <div style={{ marginBottom: 16 }}>Transaction ID: <b>{transactionId}</b></div>
      )}
      {message && (
        <div style={{ marginBottom: 16 }}>{message}</div>
      )}
       {(paymentStatus?.success || status === 'success') && (
        <div style={{ fontSize: '1.1rem', color: '#009e60', marginBottom: 16 }}>
          Your order will be delivered in <b>60 to 80 minutes</b>.
        </div>
      )}
      <button className="primary-button" style={{ minWidth: 120 }} onClick={() => navigate('/')}>Go to Home</button>
    </div>
  );
};

export default PaymentStatus;
